import React from "react";
import foto from "../../assets/12_Quienes somos/Sobre nosotros/hyundai-compromiso-ecologico.svg";

/*eslint-disable */

declare const window: any;
const RellenoComponent: React.FC = () => {
  return (
    <div className="relleno row">
      <div className="col-lg-6 col-sm-12 mb-4">
        <div className="left">
          <img src={foto} alt="Compromiso ecológico de Hyundai" />
          
          {/* H3 - Texto destacado en la imagen */}
          <h3 className="txt">
            En la era de la Cuarta Revolución Industrial, las fronteras entre
            industrias se desvanecen ante la convergencia y el cambio.
          </h3>
        </div>
      </div>
      
      <div className="col-lg-6 col-sm-12">
        <div className="right">
          {/* H2 - Título principal de la sección (implícito) */}
          {/* Si hubiera un título visible, sería H2 */}
          
          {/* H4 - Primer párrafo de descripción */}
          <h4 className="description">
            Conscientes de estas megatendencias globales, en Hyundai estamos
            acelerando la innovación impulsada por nuestra avanzada capacidad
            técnica. A lo largo de nuestros 50 años de historia, la aspiración
            de mejorar la vida humana ha sido constante. Sin ese objetivo,
            nuestras innovaciones tecnológicas no habrían sido posibles.
          </h4>
          
          {/* H4 - Segundo párrafo de descripción */}
          <h4 className="description">
            En 2019, adoptamos la visión de marca “Progreso para la Humanidad”,
            reafirmando nuestro compromiso de crear un tiempo más valioso para
            todos. Hyundai está evolucionando de ser un fabricante de
            automóviles a un proveedor de soluciones de movilidad, conectando a
            las personas con espacios y lugares, y haciendo que su tiempo sea
            más valioso. Nuestro objetivo es ofrecer servicios de movilidad que
            hagan cada momento de la vida más significativo, comprendiendo mejor
            las necesidades diarias de las personas en nuestro camino hacia el
            progreso para la humanidad.
          </h4>
        </div>
      </div>
    </div>
  );
};

export default RellenoComponent;